<app-monitor-layout #monitorContainer
  [test]="test"
  [testLoading]="testLoading$ | async"
  [patient]="patient"
  [bundle]="bundle"
  [screen]="currentDeviceScreen"
  [isTestDone]="isTestDone"
  [isTestSyncing]="isTestSyncing"
  [deviceLoading]="deviceLoading$ | async"
  [device]="device"
  [batteryPercentage]="batteryPercentage"
  [streamPopupVisible]="streamPopupVisible"
  [isSingleImage]="isSingleImage"
  [isV2Streaming]="isV2Streaming"
  [deviceActionLoading]="deviceActionLoading"
  [isLoading]="isLoading"
  [headsetAlignment]="headsetAlignment"
  (onClose)="close()"
  (onStreamOpen)="openStream($event)"
  (onStreamClose)="closeStream()"
  (onActionClicked)="onActionClicked($event)">

  <div class="monitor_container-column monitor_container-column--limit-height">
    <div
      class="monitor_graph-box monitor_graph-box--single">
      @if (isTestSyncing) {
        <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
      }
      <div class="monitor_graph-title">{{ 'both' | translate | titlecase }}</div>
      <div @startList class="monitor_list-container">
        @for (record of eyeData.slice().reverse(); track record; let i = $index) {
          <div
            @fadeAnimation
            class="monitor_list-item"
            [ngClass]="{'hidden': isRecordHidden(record, i)}">
            @if (record) {
              <ng-container *ngTemplateOutlet="recordView; context: { record: record }"></ng-container>
            } @else {
              <span class="text--blink">{{'syncing' | translate | titlecase}}...</span>
            }
          </div>
        }
        @if (!isLoading && !eyeData?.length) {
          <small>{{ isTestDone ? ('noTestDataReceived' | translate) : ('noTestData' | translate) }}</small>
        }
      </div>
    </div>
  </div>

  <div class="monitor_container-column monitor_container-column--limit-height">
    <div
      class="monitor_graph-box monitor_graph-box--single">
      @if (isTestSyncing) {
        <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
      }
      <app-percentage-circle
        id="test-percentage"
        class="monitor_circle-box"
        [percentage]="getPercentageDone()">
      </app-percentage-circle>
    </div>
  </div>
</app-monitor-layout>

<ng-template #recordView let-record="record">
  <i class="fas fa-eye" [ngClass]="{ 'orange': !record?.viewed, 'color-primary': record?.viewed }"></i>
  <span
    matTooltip="{{ 'size' | translate | titlecase }}"
    class="pointer">
    {{ record?.size_label }}
  </span>

  @if (record?.direction) {
    <app-direction-arrow
      matTooltip="{{ 'direction' | translate | titlecase }}"
      class="monitor_list-arrow"
      [direction]="record?.direction"
      [viewed]="record?.viewed">
    </app-direction-arrow>
  }

  <span>
    {{ record?.viewed ? ('seen' | translate) : ('unseen' | translate) }}
  </span>
</ng-template>

